<div class="" *ngIf="Appointments1?.length || isFilterActive">
    <!-- <div class="col-lg-12"> -->


    <!-- <div class="card m-b-30">
        <div class="card-body table-responsive"> -->
    <!-- <div class="row">
                <div align="center" class="col-lg-12">
                    <h5 class="pt-3 header-title heading-color">
                        PENDING ONLINE APPOINTMENTS REQUESTS
                    </h5>
                </div>
            </div> -->


    <!-- <div class="row" *ngIf="Appointments1?.length>0; else noRecords">
        <div class="col-md-12 mt-5 detail-tbl">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">TYPE</th>
                        <th scope="col">DATE & TIME</th>
                        <th scope="col">PATIENT </th>
                        <th scope="col">PHYSICIAN</th>
                        <th scope="col">ACTION</th>
                    </tr>
                </thead>
                <tr *ngFor="let appointment of Appointments1">
                    <td class="font-size-15">
                        <img src="/assets/images/bell-blue.png" class="ml-2" *ngIf="
                          !appointment?.request_type ||
                          appointment?.request_type ===
                            AppointmentRequestType?.NEW
                        " />
                        <img src="/assets/images/add-blue-bell.png" class="ml-2" *ngIf="
                          appointment?.request_type ===
                          AppointmentRequestType?.RESCHEDULE
                        " />
                        <img src="/assets/images/slash-bell.png" class="ml-2" *ngIf="
                          appointment?.request_type ===
                          AppointmentRequestType?.CANCELLED
                        " />
                    </td>
                    <td class="font-size-15 text-color">
                        {{ appointment?.apdate | date: dateFormat }} <br />{{ appointment?.aptime }}
                    </td>

                    <td class="font-size-15 text-color">
                        {{ appointment?.patient_first_name }}
                        {{ appointment?.patient_last_name }}
                    </td>
                    <td class="font-size-15 text-color">
                        {{ appointment?.physician_first_name }}
                        {{ appointment?.physician_last_name }}
                    </td>
                    <td class="check">
                        <div class="d-flex">
                            <div class="tabledit-toolbar btn-toolbar">
                                <div class="btn-group btn-group-sm">
                                    <button type="button" (click)="editRequest(appointment)"
                                        class="tabledit-edit-button btn btn-sm btn-info mr-2 edit">
                                        <span class="ti-pencil"></span>
                                    </button>
                                </div>
                            </div>
                            <div class="tabledit-toolbar btn-toolbar">
                                <div class="btn-group btn-group-sm">
                                    <button type="button" (click)="checkRequest(appointment)"
                                        class="tabledit-edit-button btn btn-sm btn-success mr-2">
                                        <span class="ti-check"></span>
                                    </button>
                                </div>
                            </div>
                            <div class="tabledit-toolbar btn-toolbar">
                                <div class="btn-group btn-group-sm">
                                    <button type="button" (click)="closeRequest(appointment)"
                                        class="tabledit-edit-button btn btn-sm btn-danger mr-2">
                                        <span class="ti-close"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tbody>
                    <tr></tr>
                </tbody>
            </table>
        </div>
    </div> -->


    <!-- </div>
    </div> -->


    <div class="whiteBg_container" *ngIf="Appointments1?.length>0;">
        <h3 class="fontSize19">Pending Online Appointments Requests</h3>
        <div class="table-responsive">
            <table class="table align-middle" style="background-color: #eaeffe;">
                <thead>
                    <tr>
                        <th>
                            <p>Type</p>
                        </th>
                        <th>
                            <p>Date & Time</p>
                        </th>
                        <th>
                            <p>Patient Name</p>
                        </th>
                        <th>
                            <p>Physician Name</p>
                        </th>
                        <th>
                            <p class="centerlaign">Action</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let appointment of Appointments1">
                        <td><span><img *ngIf="
                            !appointment?.request_type ||
                            appointment?.request_type ===
                              AppointmentRequestType?.NEW
                          " src="/assets/images/bell-blue.png" alt="icon">
                                <img src="/assets/images/add-blue-bell.png" class="ml-2" *ngIf="
                           appointment?.request_type ===
                           AppointmentRequestType?.RESCHEDULE" />
                                <img src="/assets/images/slash-bell.png" class="ml-2" *ngIf="
                           appointment?.request_type ===
                           AppointmentRequestType?.CANCELLED" />
                            </span>
                        </td>
                        <td>
                            <p>{{ appointment?.apdate | date: dateFormat }} | {{appointment?.aptime }}</p>
                        </td>
                        <td>
                            <p>{{ appointment?.patient_first_name }}
                                {{ appointment?.patient_last_name }}</p>
                        </td>
                        <td>
                            <p>{{ appointment?.physician_first_name }}
                                {{ appointment?.physician_last_name }}</p>
                        </td>
                        <td>
                            <p class="actionBtn">
                                <a href="#" style="float: none; margin: 5px;"><img (click)="editRequest(appointment)"
                                        src="/assets/images/editIcon.svg" alt="icon"></a>
                                <a href="#" style="float: none; margin: 5px;"><img (click)="checkRequest(appointment)"
                                        src="/assets/images/checkMarks.svg" alt="icon"></a>
                                <a href="#" style="float: none; margin: 5px;"><img (click)="closeRequest(appointment)"
                                        src="/assets/images/deleteTable.svg" alt="icon"></a>
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>




    <!-- </div> -->
</div>

<div class="" *ngIf="noAppointments">
    <div class="card m-b-30">
        <div class="card-body table-responsive">
            <div class="row">
                <div align="center" class="col-lg-12">
                    <h5 class="pt-3 header-title heading-color">
                        PENDING ONLINE APPOINTMENTS REQUESTS
                    </h5>
                </div>
            </div><br /><br />

            <div class="col-lg-12 text-center text-dark">
                No Pending Appointments
            </div>

        </div>
    </div>
</div>



<!-- Edit modal -->

<ng-template #editRequestModal let-modal>
    <div class="modal-body p-4">
        <div class="form-group row">
            <div class="col-md-12">
                <div class="row mb10">
                    <div class="col-md-6">
                        <h5 class="innerheading font-size-15 font-weight-600">
                            PATIENT INFORMATION
                        </h5>
                        <hr />
                        <div class="row">
                            <div class="col-12 d-flex pl-0">
                                <div class="col-md-6">
                                    <label class="font-color">First Name</label>
                                </div>
                                <div class="col-md-6">
                                    <p class="text-capitalize">
                                        {{ editAppoint?.patient_first_name }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex pl-0">
                                <div class="col-md-6">
                                    <label class="font-color">Last Name</label>
                                </div>
                                <div class="col-md-6">
                                    <p class="text-capitalize">
                                        {{ editAppoint?.patient_last_name }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex pl-0">
                                <div class="col-md-6">
                                    <label class="font-color">Date of Birth</label>
                                </div>
                                <div class="col-md-6">
                                    <p>
                                        {{ editAppoint?.dob | date: dateFormat }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex pl-0">
                                <div class="col-md-6">
                                    <label class="font-color">Gender</label>
                                </div>
                                <div class="col-md-6">
                                    <p class="text-capitalize">
                                        {{ editAppoint?.gender }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex pl-0">
                                <div class="col-md-6">
                                    <label class="font-color">Mobile Number</label>
                                </div>
                                <div class="col-md-6">
                                    <p>
                                        {{ editAppoint?.contact_no }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex pl-0">
                                <div class="col-md-6">
                                    <label class="font-color">Email</label>
                                </div>
                                <div class="col-md-6">
                                    <p>
                                        {{ editAppoint?.patient_email_id }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex pl-0">
                                <div class="col-md-6">
                                    <label class="font-color">Drug Allergy</label>
                                </div>
                                <div class="col-md-6">
                                    <p>
                                        {{ editAppoint?.drug_allergy ? "Yes" : "No" }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h5 class="innerheading font-size-15 font-weight-600">
                            APPOINTMENT INFORMATION
                        </h5>
                        <hr />
                        <div class="row">
                            <div class="col-12 d-flex pl-0">
                                <div class="col-md-6">
                                    <label class="font-color">Doctor Name</label>
                                </div>
                                <div class="col-md-6">
                                    <p class="text-capitalize">
                                        {{
                                        editAppoint?.physician_title
                                        ? editAppoint?.physician_title
                                        : defaultdr
                                        }}
                                        {{ editAppoint?.physician_first_name }}
                                        {{ editAppoint?.physician_last_name }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex pl-0">
                                <div class="col-md-6">
                                    <label class="font-color">Consultation</label>
                                </div>
                                <div class="col-md-6">
                                    <p class="text-capitalize">
                                        {{ editAppoint?.apttype }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <form [formGroup]="editAptForm">
                            <div class="row">
                                <div class="col-12 d-flex pl-0">
                                    <div class="col-md-6">
                                        <label class="font-color">Appointment Date</label>
                                    </div>
                                    <div class="col-md-6">
                                        <p>
                                            <editable>
                                                <ng-template viewMode>
                                                    {{ editAppoint.apdate | date: dateFormat }}
                                                    <div *ngIf="
                                editAptForm.get('apDate').hasError('ngbDate')
                              " class="invalid-feedback">
                                                        Appointment Date is invalid
                                                    </div>
                                                </ng-template>
                                                <ng-template editMode>
                                                    <div class="d-flex">
                                                        <input class="form-control"
                                                            placeholder="Appointment Date (DD/MM/YYYY)"
                                                            name="appointDate" ngbDatepicker #appoint="ngbDatepicker"
                                                            data-date-inline-picker="false" id="appointDate"
                                                            [minDate]="currentDate" formControlName="apDate"
                                                            (dateSelect)="dateTimeChangeEvent()" focusable />
                                                        <div>
                                                            <button
                                                                class="btn btn-outline-secondary button-height calendar rounded-0"
                                                                (click)="appoint.toggle()" type="button"
                                                                id="AppointButton">
                                                                <span class="fa fa-calendar"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="
                                editAptForm.get('apDate').hasError('ngbDate')
                              " class="invalid-feedback">
                                                        Appointment Date is invalid
                                                    </div>
                                                </ng-template>
                                            </editable>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 d-flex pl-0">
                                    <div class="col-md-6">
                                        <label class="font-color">Appointment Time</label>
                                    </div>
                                    <div class="col-md-6">
                                        <p>
                                            <editable>
                                                <ng-template viewMode>
                                                    <!-- {{ editAppoint.aptime }} -->
                                                    {{aptime}}
                                                    <div *ngIf="
                                editAptForm
                                  .get('apTime')
                                  .hasError('invalidStartTime')
                              " class="invalid-feedback">
                                                        Appointment Time is invalid
                                                    </div>
                                                </ng-template>
                                                <ng-template editMode>
                                                    <ngb-timepicker formControlName="apTime" meridian="true"
                                                        (ngModelChange)="dateTimeChangeEvent()" focusable>
                                                    </ngb-timepicker>
                                                    <div *ngIf="
                                editAptForm
                                  .get('apTime')
                                  .hasError('invalidStartTime')
                              " class="invalid-feedback">
                                                        Appointment Time is invalid
                                                    </div>
                                                </ng-template>
                                            </editable>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-md-6"></div>
                            <div class="col-md-6 pl-0">
                                <button class="btn btn-sm btn-primary btn-rounded" (click)="openCalendarMOdal()">
                                    View Calendar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12 d-flex pl-0">
                                <div class="col-md-3">
                                    <label class="font-color">Concern</label>
                                </div>
                                <div class="col-md-9">
                                    <p>
                                        {{ editAppoint?.remarks }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 mt-3">
                        <p class="text-danger">
                            <em>Note: Please contact the patient before changing the
                                appointment time.</em>
                        </p>
                    </div>
                </div>

                <div class="row my-3">
                    <div class="col-sm-12 text-center">
                        <button type="button" class="btn btn-primary pl-5 pr-5 mr-2 btn-rounded"
                            [disabled]="editAptForm.invalid" (click)="editAppointment('edit')">
                            Approve
                        </button>
                        <button type="button" class="btn bg-color text-white pl-5 pr-5 btn-rounded"
                            (click)="modal.dismiss()">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- check modal -->

<ng-template #checkRequestModal let-modal>
    <div class="modal-body p-5">
        <div class="row">
            <div class="col-md-3">
                <img src="/assets/images/check-health.svg" class="" />
            </div>
            <div class="col-md-9 mt-2">
                <div class="font-size-20 font-weight-400">
                    Are you sure you want to accept appointment?
                </div>
                <p class="text-success mt-2 font-size-22 font-weight-500">
                    This action cannot be undone!
                </p>
                <div class="mt-4 mb-4">
                    <button type="button" class="btn text-white bg-color btn-rounded mr-2 pl-4 pr-4"
                        (click)="modal.dismiss()">
                        OOPS! NO. CANCEL
                    </button>
                    <button type="button" class="btn btn-primary mt-md-0 mt-2 mr-2 btn-rounded pl-5 pr-5"
                        (click)="editAppointment('approve')">
                        I AM SURE
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- close modal -->

<ng-template #closeRequestModal let-modal>
    <div class="modal-body p-5">
        <div class="row">
            <div class="col-md-3">
                <img src="/assets/images/close-health-icon.png" class="" />
            </div>
            <div class="col-md-9 mt-2">
                <div class="font-size-20 font-weight-400">
                    Are you sure you want to decline appointment?
                </div>
                <p class="text-danger mt-2 font-size-22 font-weight-500">
                    This action cannot be undone!
                </p>
                <div class="mt-4 mb-4">
                    <button type="button" class="btn text-white bg-color btn-rounded mr-2 pl-4 pr-4"
                        (click)="modal.dismiss()">
                        OOPS! NO. CANCEL
                    </button>
                    <button type="button" class="btn btn-primary mt-md-0 mt-2 mr-2 btn-rounded pl-5 pr-5"
                        (click)="editAppointment('cancel')">
                        I AM SURE
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>